<div class="wrap uk-margin-top">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-margin-small-top" style="padding-left: 20px;"
                *ngIf="session.role.ability === 'super-admin'">
                <div class="back-button" [routerLink]="['/user/society/list']">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>Liste des adhérents</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">{{ society.Name }}</div>
                <div class="uk-align-right@s">
                    <button class="back-button button-main-title regular buttonMobile" type="submit"
                        (click)="updateSociety()" style="padding-right: 20px;"
                        [attr.uk-tooltip]="formChanged === false ? 'Aucun changement à valider' : null"
                        [disabled]="formChanged === false">
                        <span class="uk-visible@s uk-text-uppercase">Valider les changements</span>
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 uk-margin-top vop-background-white remove-grid-ml-pl"
                style="padding-bottom: inherit;">
                <div class="uk-width-4-12@s" style="min-height: 316.66px;">
                    <div class="img-wrap">
                        <img src="../../../../assets/img/undefined.png"
                            onerror="this.src='../../../../assets/icons/Adherent.svg';this.className='img-error';">
                    </div>
                </div>
                <div class="uk-width-8-12 uk-grid-small" uk-grid>
                    <div class="uk-width-2-3@s">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Nom</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="society.Name">
                            </div>
                        </div>
                        <div class="uk-margin-left  uk-margin-bottom">
                            <label class="label">Adresse</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="society.Address">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3@s">
                        <div class="uk-margin-left uk-margin">
                            <label class="label">Téléphone</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="society.Mobile">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin">
                            <label class="label">Code société</label>
                            <div class="uk-form-controls">
                                <span *ngIf="session.role.ability !== 'super-admin'"
                                    class="color-cold-grey bold uk-width-1-1">{{ society.Code }}</span>
                                <input *ngIf="session.role.ability === 'super-admin'"
                                    class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="society.Code">
                                <!-- <input class="input alt color-cold-grey bold uk-width-1-1" type="text" [(ngModel)]="society.Code"> -->
                            </div>
                        </div>
                        <!-- A Ajouter lorsque Facturation entreprise terminé -->
                        <!-- <div class="uk-margin-left">
                            <label class="label">Commission VOP (%)</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" min="0" max="100" step="0.01"
                                    type="number" [(ngModel)]="society.Commission">
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="title bold">
                    Membres de l'équipe de {{ society.Name }}
                </div>

                <div class="uk-margin-small-top" *ngIf="noMemberResult === true">
                    <span>Aucun membre dans l'équipe de {{ society.Name }}</span>
                </div>

                <div *ngIf="loadingMember === true">
                    <div uk-spinner class="uk-text-center uk-width-1-1"></div>
                </div>

                <div class="uk-margin-medium-top" *ngIf="loadingMember === false && noMemberResult === false">
                    <div uk-grid *ngFor="let member of members; let i = index"
                        class="uk-width-1-1 item-list dark remove-grid-ml-pl">
                        <div class="uk-visible@s uk-width-1-12 item-column">
                            <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/User.svg"
                                width="64px" height="64px" alt="user" />
                        </div>
                        <div class="uk-width-3-12 item-column uk-margin-small-left pointer"
                            [routerLink]="['/user/informations', member.AccountId]"
                            [queryParams]="{from: '/user/society/informations/'+id, name: 'Adherent ' + society.Name }">

                            <span>{{ member.FirstName }} {{ member.LastName }}</span>
                        </div>
                        <div class="uk-width-expand item-column">
                            <div class="uk-text-center">
                                <button disabled
                                    class="uk-visible@s uk-button round-button bigger uk-display-inline-block">Admin</button>
                                <button disabled
                                    class="uk-visible@s uk-button round-button bigger uk-display-inline-block uk-margin-small-left">Tarif
                                    pro</button>
                                <button
                                    class="uk-button round-button bigger round-button-toggle uk-display-inline-block uk-margin-small-left">Staff</button>
                            </div>
                        </div>
                        <div class="uk-width-1-12 item-column">
                            <img (click)="deleteSocietyMember(member)" class="uk-position-absolute pointer"
                                style="right: 20px; filter: brightness(200%);" src="../../../assets/icons/delete.svg"
                                width="32px" height="32px" alt="delete" />
                        </div>
                    </div>
                </div>
                <div>
                    <a class="button bold uk-float-right add-user uk-margin-medium-top" href="#find-user" uk-toggle>
                        <span>Ajouter un membre</span>
                        <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="add" class="uk-margin-left">
                    </a>
                </div>
            </div>
            <!-- <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    <span>Tarification {{ society.Code }}</span>
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-4">
                        <div class="uk-margin">
                            <label class="label">Prix horaire</label>
                            <div class="uk-form-controls uk-margin-small-top"> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">5€</span> <span class="regular">(40€/journée)</span> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">{{ prixHoraire }}€</span>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-4">
                        <div class="uk-margin">
                            <label class="label">Prix journalier</label>
                            <div class="uk-form-controls uk-margin-small-top"> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">40€</span> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">{{ prixJournalier }}€</span>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-4">
                        <div class="uk-margin">
                            <label class="label">Prix au kilomètre</label>
                            <div class="uk-form-controls uk-margin-small-top"> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">0.3€</span> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">{{ prixKilometre }}€</span>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-4">
                        <div class="uk-margin">
                            <label class="label">Remises</label>
                            <div class="uk-form-controls uk-margin-small-top"> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">50 km inclus par réservation</span> -->
            <!-- <span class="color-cold-grey bold uk-width-1-1">{{ remise }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px; padding-bottom: 0px;">
            </div> -->

        </div>
    </div>
</div>

<app-rate-management class="simulateur" *ngIf="session.role.ability === 'super-admin'"></app-rate-management>

<app-find-user (changed)="addSocietyMember($event)"></app-find-user>